import shoppableImage from '../helpers/ShoppableImage';

let module_name = '';
const getImages = (images) => {
  return images
    .map((image) => {
      const caption = image.caption ? `<div class="Module-${module_name}__image-caption">${image.caption}</div>` : '';
      return `
    <div class="Module-${module_name}__image" data-cms-image-slider-slide>
      ${shoppableImage(image)}
      ${caption}
    </div>`;
    })
    .join('');
};

export default (settings, name) => {
  module_name = name;

  const images = getImages(settings.images || []);
  const html = `
  <div class="Module-${module_name}__Content">
    <div class="Module-${module_name}__Images" data-cms-image-slider>
      <div class="ScrollCarousel__viewport" data-cms-image-slider-viewport>
        <div class="ScrollCarousel__track" data-cms-image-slider-track>
          ${images}
        </div>
      </div>
    </div>
  </div>
  `;
  return html;
};
